import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from 'components/base/base.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { lastValueFrom } from 'rxjs';
import { Perfil } from 'src/app/shared/enums/Perfis/Perfis';
import { Diretoria } from 'src/app/shared/models/diretoria/Diretoria';
import { Escola } from 'src/app/shared/models/escola/Escola';
import { FiltroPadrao } from 'src/app/shared/models/filtro-padrao/filtroPadrao';
import { AjustarJornada, JornadaPsicologo, JornadaPsicologosInserir } from 'src/app/shared/models/psicologo/JornadaPsicologo';
import { AtribuicaoLoginSed } from 'src/app/shared/models/sed/UserLogin';
import { FiltroTabulator } from 'src/app/shared/models/tabulator/FiltroTabulator';
import { ConvivaErrorHandlingService } from 'src/app/shared/services/convivaErrorHandlingService';
import { FiltroService } from 'src/app/shared/services/filtro.service';
import { angularCommonImports } from 'src/app/shared/ui/angular-common';
import { convivaCommonImports } from 'src/app/shared/ui/conviva-common';
import { libsCommonImports } from 'src/app/shared/ui/libs-common';

@Component({
    templateUrl: './consulta-ponto.component.html',
    styleUrls: ['./consulta-ponto.component.scss'],
    imports: [convivaCommonImports,angularCommonImports,libsCommonImports],
    standalone: true,
    providers: [NgxSpinnerService, ConvivaErrorHandlingService,FormBuilder,FiltroService]
})

export class PageConsultaPontoComponent extends BaseComponent implements OnInit {

  //Injections
  spinner = inject(NgxSpinnerService);
  errorHandler = inject(ConvivaErrorHandlingService);
  fb = inject(FormBuilder);
  filtroService = inject(FiltroService);

  filtrosTabela:FiltroTabulator[] = [
    {
      value:'nomePsicologo',
      label:'Psicólogo'
    },
    {
      value:'dataEntrada',
      label:'Data Entrada'
    },
    {
      value:'poloDiretoria',
      label:'Polo/Diretoria'
    }
  ] ;

  formInserir!: FormGroup;
  jornadas:JornadaPsicologo[] = [];
  jornadaAtiva?:JornadaPsicologo ;
  escolasDiretor: Escola[] = this.escolas;
  modalAjustePonto = false;
  modalInserirPonto = false;

  form:FormGroup = this.fb.group({
    justificativa: new FormControl('',[Validators.required,Validators.maxLength(500)]),
    tipoRegistro: new FormControl('1',[Validators.required]),
    hora: new FormControl('',[Validators.required]),
  });

  get formControls(){
    return this.form.controls;
  }

  get podeVerColuna() {
    return [
      Perfil.GestorConviva,
      Perfil.GestorCGRH,
      Perfil.PEC,
      Perfil.CoordenadorPsicologo,
      Perfil.FiscalPsicologo
    ].includes(this.userLogado?.codigoPerfil!);
  }

  public colunasGrid = [
    { title: 'Psicólogo', field: 'nomePsicologo', width:200, hozAlign: "center",headerHozAlign:"center"  },
    { title: 'Data Entrada', field: 'dataEntrada', width:150, hozAlign: "center",headerHozAlign:"center" },
    { title: 'Observação', field: 'observacao', width:200, hozAlign: "center",headerHozAlign:"center",formatter:this.observacaoFormatter},
    { title: 'Entrada / Saída', field: 'entradaSaida',width:150 ,hozAlign: "center" },
    { title: 'Polo / Diretoria', field: 'poloDiretoria', width:200, hozAlign: "center",headerHozAlign:"center", formatter:"textarea" },
    { title: 'Escola', field: 'escolaFormatada', width:200, hozAlign: "center",headerHozAlign:"center", formatter:"textarea" },
    { title: 'Lat/Long Inicio', field: 'latLongInicio', width:180, hozAlign: "center",headerHozAlign:"center"  },
    { title: 'Distância Inicio', field: 'distanciaEscolaInicio', width:150, hozAlign: "center",headerHozAlign:"center" , visible:this.podeVerColuna},
    { title: 'Lat/Long Fim', field: 'latLongFim', width:180, hozAlign: "center",headerHozAlign:"center"  },
    { title: 'Distância Fim', field: 'distanciaEscolaFim', width:150, hozAlign: "center",headerHozAlign:"center" ,visible:this.podeVerColuna },
    { title: 'Tipo Registro', field: 'tipoRegistroInicio', width: 150, hozAlign: 'center', headerHozAlign: 'center', formatter: 'lookup', formatterParams: { 1: 'Automático', 2: 'Manual', 3: 'Ajustado',},},
    { title: 'Ações', field: 'acoes', hozAlign: "center", width:100, formatter: function (cell: any, formatterParams: any, onRendered: any) {
        return  `<div style='display:inline-flex;gap:0.4em;'> <i class='fa fa-edit'  aria-hidden='true'></i>`;
    },headerHozAlign:"center", cellClick:(e:any,cell:any)=>  this.abrirModalRelogioPonto(e,cell) ,visible:this.podeVerColuna},

  ];

  public async ngOnInit() {
    this.formInserir = new FormGroup({
      justificativa:new FormControl(null,[Validators.required, Validators.maxLength(500)]),
      tipoRegistro: new FormControl(),
      horaEntrada:new FormControl(null, [Validators.required]),
      horaSaida:new FormControl(null, [Validators.required]),
      codigoDiretoria: new FormControl(null, [Validators.required]),
      codigoEscola: new FormControl(null, [Validators.required]),
    });
  }

  abrirModalRelogioPonto(e:any,cell:any): void {
    const jornada = cell.getData();
    this.jornadaAtiva = jornada;
    if(!this.jornadaAtiva?.dataFim){
      this.toastr.warning('Não é possível ajustar jornadas não finalizadas!','Atenção!');
      return;
    }
    this.modalAjustePonto = true;
  }

  async abrirModalInserirRegistro(): Promise<void> {
    await this.UserBehavior();
    this.formInserir.get('codigoDiretoria')?.reset();
    this.escolas = [];
    this.modalInserirPonto = true;
  }

  closeModalAjustePonto(): void {
    this.jornadaAtiva = undefined;
    this.formControls.hora.setValue(null);
    this.formControls.justificativa.setValue(null);

    this.modalAjustePonto = false;
  }

  closeModalInserirPonto(): void {
    this.modalInserirPonto = false;
  }

    closeModalInserirRegistroPonto(): void {


    this.modalInserirPonto = false;
  }

  async getJornadas(filtros:FiltroPadrao){
    this.spinner.show();

    const response = await lastValueFrom(this.psicologoService.getJornadas(
      filtros.codigoPolo!,
      filtros.codigoDiretoria,
      filtros.codigoEscola,
      this.userLogado?.codigoPerfil == Perfil.Psicólogo ? this.userLogado?.cpf : null))
    .catch(err => this.errorHandler.handleResultError(err));
    if(!response.isSucess){
      this.toastr.error(response.message, response.title);
      this.spinner.hide();
      return;
    }
    this.jornadas = response.data;
    this.toastr.success("Jornadas encontradas com sucesso!");
    this.spinner.hide();
  }

  public async UserBehavior() {

      if (this.userLogado?.flPsicologo) {
        await this.getDiretoriasPerfilPsicologo();
      }
      else {
        if (this.atribuicoesLogin.NumeroComportamento == 1) {
          await this.getDiretoriasAdmin();
        }

        if (this.atribuicoesLogin.NumeroComportamento == 2) {
          await this.getDiretoriasPerfilDiretoria();
        }

        if (this.atribuicoesLogin.NumeroComportamento == 3 ||
          this.atribuicoesLogin.NumeroComportamento == 4) {
          await this.getDiretoriasPerfilEscola();
        }
      }


    this.disableVoidInputs();
    await this.activeDiretoria();
  }

  setUserLogado(){
    const user = this.authService.getUser();
    if(!user)
      this.router.navigate(['/logout']);

    return user;
  }

  observacaoFormatter(cell: any) {
    const value = cell.getValue();
    return value ? value : 'sem observação'; // Retorna "sem observação" se o valor for null ou vazio
  }

  private async getDiretoriasPerfilPsicologo() {
    this.spinnerService.show();
    const response = await lastValueFrom(this.psicologoService.getDiretoriaPorPolo(this.userLogado!.codigoPolo));
    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.diretorias = response.data;
    this.spinnerService.hide();


  }

  public async getDiretoriasAdmin() {
    this.spinnerService.show();


    const response = await lastValueFrom(this.escolaService.getDiretoriaPorTipoDiretoria())
      .catch((err) => {
        return this.errorHandler.handleResultError(err);
      });

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.diretorias = response.data;
    this.spinnerService.hide();


  }

  public getDiretoriasPerfilDiretoria() {
    this.diretorias = [];
    this.escolas = [];
    this.spinnerService.show();

    this.userLogado?.DadosUsuario?.map((item: AtribuicaoLoginSed) => {
      const diretoria = new Diretoria();
      diretoria.codigoDiretoria = item.CodigoDiretoria;
      diretoria.nomeDiretoria = item.NomeDiretoria;
      this.diretorias.push(diretoria);

    });

    if (this.diretorias.length === 1) {
      this.formInserir.get('codigoDiretoria')!.disable();
    }

    this.spinnerService.hide();

  }

  public getDiretoriasPerfilEscola() {

    this.diretorias = [];
    this.escolas = [];

    this.spinnerService.show();
    this.userLogado?.DadosUsuario?.map((item: AtribuicaoLoginSed) => {
      const diretoria = new Diretoria();
      diretoria.codigoDiretoria = item.CodigoDiretoria;
      diretoria.nomeDiretoria = item.NomeDiretoria;
      this.diretorias.push(diretoria);

      const escola = new Escola();
      escola.codigoEscola = item.CodigoEscola;
      escola.nomeEscola = item.NomeEscola;
      escola.codigoDiretoria = item.CodigoDiretoria;
      this.escolas.push(escola);
      this.escolasDiretor.push(escola);

    });
    this.spinnerService.hide();



  }

  async activeDiretoria() {

    if (this.diretorias != undefined && this.userLogado?.codigoDiretoria != 0) {
      const diretoria = this.diretorias.find(s => s.codigoDiretoria == this.userLogado?.codigoDiretoria)
      if (diretoria) {
        this.formInserir.get('codigoDiretoria')!.setValue(this.userLogado?.codigoDiretoria);
        this.formInserir.get('codigoDiretoria')!.enable();
        await this.getEscolas();
      }
    }
  }

  async activeEscola() {
    if (this.escolas != undefined && this.userLogado?.codigoEscola != 0) {
      const escola = this.escolas.find(s => s.codigoEscola == this.userLogado?.codigoEscola)
      if (escola) {
        this.formInserir.get('codigoEscola')!.setValue(this.userLogado?.codigoEscola);
      }
    }
  }

  disableVoidInputs() {

    // if(this.template == TemplateFiltroPadrao.Polo){
    //   this.form.codigoDiretoria.setValue(null);
    //   this.form.codigoDiretoria.disable();
    // }
    this.formInserir.get('codigoDiretoria')!.setValue(null);
    this.formInserir.get('codigoDiretoria')!.disable();
    this.formInserir.get('codigoEscola')!.setValue(null);
    this.formInserir.get('codigoEscola')!.disable();
  }

  async ajustarPonto(){
    this.spinner.show();
    if(this.form.invalid){
      this.toastr.warning('Preencha os campos obrigatórios!',"Atenção!");
      this.spinner.hide();
      return;
    }

    const body = this.SetBodyParameters();
    const response = await lastValueFrom(this.psicologoService.setAjustarJornada(body))
    .catch(err => this.errorHandler.handleResultError(err));
    if(!response.isSucess){
      this.toastr.error(response.message, response.title);
      this.spinner.hide();
      return;
    }
    this.toastr.success("Ponto ajustado com sucesso!");
    this.spinner.hide();
    this.closeModalAjustePonto();
    await this.getJornadas(this.filtros);
  }

  async inserirJornada(){
    this.spinner.show();
    if(this.formInserir.invalid){
      this.toastr.warning('Preencha os campos obrigatórios!',"Atenção!");
      this.spinner.hide();
      return;
    }

  const { horaEntrada, horaSaida } = this.formInserir.value;

  const dataInicio = new Date(horaEntrada);
  const agora = new Date();

  if (dataInicio > agora) {
    this.toastr.warning('A data e hora de início não pode ser maior que o momento atual.', 'Atenção!');
    this.spinner.hide();
    return;
  }

  const [dataParte] = horaEntrada.split('T');
  const [horas, minutos] = horaSaida.split(':');
  const dataFimIso = `${dataParte}T${horas.padStart(2, '0')}:${minutos.padStart(2, '0')}`;
  const dataFim = new Date(dataFimIso);

  if (dataFim < dataInicio) {
    this.toastr.warning('O horário de saída não pode ser anterior ao horário de entrada.', 'Atenção!');
    this.spinner.hide();
    return;
  }

    const body = this.SetBodyParametersInserir();

    const response = await lastValueFrom(this.psicologoService.setInserirJornadaAnterior(body))
    .catch(err => this.errorHandler.handleResultError(err));
    if(!response.isSucess){
      this.toastr.error(response.message, response.title);
      this.spinner.hide();
      return;
    }
    this.toastr.success("Ponto ajustado com sucesso!");
    this.formInserir.reset();
    this.spinner.hide();
    this.closeModalInserirPonto();
  }

    SetBodyParametersInserir():JornadaPsicologosInserir{
  const { horaEntrada, horaSaida } = this.formInserir.value;

  const [dataParte] = horaEntrada.split('T');

  const [horas, minutos] = horaSaida.split(':');

  const dataFimIso = `${dataParte}T${horas.padStart(2,'0')}:${minutos.padStart(2,'0')}`;
  const dataFimDate = new Date(dataFimIso);
  const DataFimLocal   = this.formatLocalISO(dataFimDate);

  const escolaSem = this.escolas.find(x =>
         x.codigoEscola == this.formInserir.get('codigoEscola')?.value);

  const nomeEscolaSemCodigo = escolaSem?.nomeEscola.replace(/^[0-9]+\s*-\s*/, '')?? '';

    return {
      codigoDiretoria:this.formInserir.get('codigoDiretoria')?.value,
      codigoEscola:this.formInserir.get('codigoEscola')?.value,
      nomeDiretoria:this.diretorias.find(x => x.codigoDiretoria == this.formInserir.get('codigoDiretoria')?.value)?.nomeDiretoria,
      nomeEscola:nomeEscolaSemCodigo,
      justificativa:this.formInserir.get('justificativa')?.value,
      codigoPsicologo:Number(this.userLogado?.cpf),
      dataInicio: horaEntrada,
      dataFim:    DataFimLocal,
    };
  }

  public formatLocalISO(dt: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  const Y = dt.getFullYear();
  const M = pad(dt.getMonth() + 1);
  const D = pad(dt.getDate());
  const h = pad(dt.getHours());
  const m = pad(dt.getMinutes());
  return `${Y}-${M}-${D}T${h}:${m}`;
  }

  SetBodyParameters():AjustarJornada{
    let dataAlteracao = this.form.get('tipoRegistro')?.value === '1' ?
    this.jornadaAtiva?.dataInicio : this.jornadaAtiva?.dataFim;
    const hora = this.form.get('hora')?.value;
    if (dataAlteracao && hora) {
      const data = new Date(dataAlteracao);
      const [hours, minutes] = hora.split(':');
      data.setHours(Number(hours - 3), Number(minutes), 0, 0);
      dataAlteracao = data;
  }

    return {
      codigoJornada:this.jornadaAtiva?.codigoJornada!,
      justificativa:this.form.get('justificativa')?.value,
      tipoAjuste:Number(this.form.get('tipoRegistro')?.value),
      dataAjuste:dataAlteracao!,
      codigoUsuario:Number(this.userLogado?.cpf),
      nomeUsuario:this.userLogado?.nome!
    };
  }

  async searchHandler(event:FiltroPadrao){
    this.filtros = event;
    await this.getJornadas(this.filtros);
  }

  async listeningFiltroEmitter(eventFilter: FiltroPadrao) {

    this.setFilters(eventFilter);

    this.filtroService.atualizaFiltro(eventFilter);

  }

  setFilters(event: FiltroPadrao) {
    this.filtros = event;

  }

  public async getEscolas( ) {
    this.spinnerService.show();

    const codigoDE = this.formInserir.get('codigoDiretoria');
    if(this.userLogado?.DadosUsuario[0]?.NumeroComportamento == 1 ||
       this.userLogado?.DadosUsuario[0]?.NumeroComportamento == 2 ||
        this.userLogado?.DadosUsuario[0].CodigoPerfil == Perfil.Psicólogo){
      //this.zerarEscola();
      if (codigoDE?.value != null) {
        this.spinnerService.show();
        const response = await lastValueFrom( this.escolaService.getEscolasPorCodigoDiretoria(codigoDE?.value));
          if(!response.isSucess){
            this.toastr.error(response.message);
          }
          this.escolas = response.data;
          this.formInserir.get('codigoEscola')!.enable();
          this.spinnerService.hide();
      }
    }
    this.spinnerService.hide();
  }

  public zerarEscola() {
    this.escolas = [];
    this.formInserir.get('codigoEscola')!.patchValue(null);
    this.formInserir.get('codigoEscola')!.disable();
  }
}


